import React from 'react';

export default ({ color }) => (
  <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="1.29289" y1="14.2929" x2="8.79289" y2="6.79289" stroke={color} strokeWidth="2" />
    <line
      y1="-1"
      x2="10.6066"
      y2="-1"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 2 0)"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/faqpage/components/icons/RightCaretBoldIcon.tsx